import { lazyLoad } from '../../../shared/utils/loadable';

export const ProviderConfirmPage = lazyLoad(
  () => import('./index'),
  (module) => module.ProviderConfirm,
);
